import { DimensionamentoService } from "../../../services/DimensionamentoServices";
import { convertFileToUtf8 } from "../../../utils/encodingUtils";
import {
  showFileNotSelectedAlert,
  showProcessingSuccessAlert,
  showRegistrationErrorAlert,
  showErrorRecordsAlert,
  showInvalidRecordsAlert,
  showDataReplacementConfirmation,
  showRestartConfirmation,
} from "./alertUtils";
import Swal from 'sweetalert2';

export async function processFileUpload(
  file,
  setBeneficiarios,
  setInvalidRecords,
  setShowInvalidData
) {
  if (!file) {
    await showFileNotSelectedAlert();
    throw new Error("No file selected");
  }

  const utf8File = await convertFileToUtf8(file);
  
  if (utf8File !== file) {
    await Swal.fire({
      title: "Conversão de Codificação",
      text: "O arquivo foi automaticamente convertido para UTF-8 para garantir a exibição correta dos caracteres.",
      icon: "info",
      confirmButtonText: "Continuar",
      timer: 3000,
      timerProgressBar: true
    });
  }

  const response = await DimensionamentoService.uploadFileBeneficiarios(utf8File);
  setBeneficiarios(response["beneficiariosWithAdditionalData"]);

  if (response["errorRecords"] && response["errorRecords"].length > 0) {
    await showErrorRecordsAlert(response["errorRecords"]);
  }

  if (
    response["beneficiariosWithoutAdditionalData"] &&
    response["beneficiariosWithoutAdditionalData"].length > 0
  ) {
    setInvalidRecords(response["beneficiariosWithoutAdditionalData"]);
    const result = await showInvalidRecordsAlert(
      response["beneficiariosWithoutAdditionalData"]
    );

    if (result.isDenied) {
      setShowInvalidData(true);
    }
  } else {
    await showProcessingSuccessAlert();
  }

  return response;
}

export async function registerBeneficiarios(beneficiarios) {
  try {
    await DimensionamentoService.postBeneficiarios(beneficiarios);
  } catch (error) {
    console.error(error);
    await showRegistrationErrorAlert();
    throw error;
  }
}

export function loadExistingBeneficiaryData(setBeneficiaryData) {
  DimensionamentoService.getBeneficiariosDemografico().then((r) => {
    setBeneficiaryData(r);
  });
}

export async function handleRegistrationConfirmation(
  beneficiaryData,
  handlePostBeneficiarios
) {
  if (beneficiaryData && beneficiaryData.header) {
    const result = await showDataReplacementConfirmation();
    if (result.isConfirmed) {
      handlePostBeneficiarios();
    }
    return;
  }

  handlePostBeneficiarios();
}

export async function handleStepReset(
  currentStep,
  beneficiarios,
  resetAllStates
) {
  if (currentStep !== 1) {
    if (currentStep >= 3 && beneficiarios) {
      const result = await showRestartConfirmation();
      if (result.isConfirmed) {
        resetAllStates();
      }
    } else {
      resetAllStates();
    }
  }
}
